<template>
    <a href="#" :title="text.toggle_field_lock" class="padlock" :class="[{'locked': locked},{'unlocked': locked === false}]" @click="onClick($event)">{{text.toggle_field_lock}}</a>
</template>

<script>
    import {log} from '@/shared/utils'
    import lang from '@/shared/lang';

    export default {
        name: "Lock",
        props: {
            locked: {
                type: Boolean,
            },
        },
        computed: {
            text() {
                return lang;
            },
        },
        methods: {
            onClick(e) {
                e.preventDefault();

                log("Action fired");

                this.$emit('toggleLocked')
            }
        },
    }
</script>